import type { TicketTierDto } from '../api/tickets.api';
import { etichetaStare, type StareStructurala } from './rang';
import type { TierState } from './tier-state';

/**
 * Ce spune un rand din lista UNICA de niveluri (item 15): pozitia scolii fata de nivel si, separat,
 * ce poate face acum cu el.
 *
 * Doua familii de stare pe acelasi rand, si nu se amesteca (vezi `rang.ts`):
 *   - POZITIA vine din `earned` -> „Nivelul tău" / „Atins" / „Mai ai N puncte";
 *   - REVENDICAREA vine din `computeTierState` (sold, fereastra, limita) -> buton sau nota.
 *
 * Modul pur: ce se afiseaza se decide aici, testat, nu in `.tsx`.
 */

/** Puncte CASTIGATE care mai lipsesc pana la nivel. Din `earned`, nu din sold. Niciodata negativ. */
export function puncteLipsaNivel(tier: TicketTierDto, earned: number): number {
    return Math.max(0, (tier.pointsCost ?? 0) - earned);
}

/** Cifrele cu separatorul romanesc („2.200"), ca in restul paginii. */
function cifra(n: number): string {
    return n.toLocaleString('ro-RO');
}

/** Eticheta scrisa a pozitiei. La un nivel neatins, eticheta E distanta — „blocat" fara cifra n-ar spune nimic. */
export function etichetaNivel(stare: StareStructurala, lipsa: number): string {
    if (stare === 'neatins') return `Mai ai ${cifra(lipsa)} puncte`;
    return etichetaStare(stare);
}

/**
 * Se arata nota de sub nivel (in locul butonului „Revendică")?
 *
 * Nu, cand nivelul e disponibil — atunci e butonul. Si nu, cand nivelul e NEATINS si singurul motiv e
 * soldul: eticheta spune deja „Mai ai N puncte", iar a doua propozitie cu aproape aceeasi cifra ar fi
 * zgomot. Ramane nota la un nivel ATINS pe care soldul nu-l mai acopera (scoala a cheltuit), la
 * limita atinsa si la fereastra de revendicare — toate trei sunt informatie noua.
 */
export function arataNotaRevendicare(state: TierState, stare: StareStructurala): boolean {
    if (state.kind === 'available') return false;
    if (state.kind === 'insufficient' && stare === 'neatins') return false;
    return true;
}
